import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import React from 'react';

interface ComingSoonProps {
  title: string;
  description?: string;
}

export const ComingSoon: React.FC<ComingSoonProps> = ({ title, description }) => {
  return (
    <div className="coming-soon">
      <ConstructionOutlinedIcon />
      <div className="coming-soon-title">{title}</div>
      {description && <div className="coming-soon-desc">{description}</div>}
    </div>
  );
};
